// const image_validations = file => {
//   if (file) {
//   }
// };

// Email validation
export const emailIsValid = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// URL Validation
export const UrlIsValid = myURL => {
  var pattern = new RegExp(
    "^(?:(?:http(?:s)?|ftp)://)(?:\\S+(?::(?:\\S)*)?@)?(?:(?:[a-z0-9\u00a1-\uffff](?:-)*)*(?:[a-z0-9\u00a1-\uffff])+)(?:\\.(?:[a-z0-9\u00a1-\uffff](?:-)*)*(?:[a-z0-9\u00a1-\uffff])+)*(?:\\.(?:[a-z0-9\u00a1-\uffff]){2,})(?::(?:\\d){2,5})?(?:/(?:\\S)*)?$"
  );
  return pattern.test(myURL);
};

// Checking if the any field is empty
const isEmpty = obj => {
  console.log(obj);
  // return false;
  if (Object.keys(obj).length === 0) {
    return true;
  }
  return Object.values(obj).some(
    value => value == "" || value === null || value === undefined
  );
};

// Form Validations of Post Job
export const checkValidationErrors = obj => {
  let error = {};
  if (isEmpty(obj)) {
    error.emptyFields = "Please fill out All Required Fields.";
  }
  if (
    obj.howToApply &&
    !emailIsValid(obj.howToApply) &&
    !UrlIsValid(obj.howToApply)
  ) {
    error.howToApply = "This must be a valid email or URL.";
  }
  if (obj.companyEmail && !emailIsValid(obj.companyEmail)) {
    error.companyEmail = "This must be a valid email.";
  }
  if (obj.companyWebsiteURL && !UrlIsValid(obj.companyWebsiteURL)) {
    error.companyWebsiteURL = "This must be a valid URL.";
  }
  if (
    obj.companyConfirmationEmail &&
    !emailIsValid(obj.companyConfirmationEmail)
  ) {
    error.companyConfirmationEmail = "This must be a valid email.";
  }
  return Object.values(error).length > 0 ? error : null;
};
